import axios from "axios";
import customConfig from "../config";
import store from "../store";
import { setAlert } from "../action/alert";
import {
  refreshAccessToken,
  clearStoredAuthSlices,
  USER_MANAGEMENT_TOKEN_REFRESH_PATH,
} from "./tokenRefresh";

// Default timeout for all requests (can be overridden per-request)
axios.defaults.timeout = 30000;

const sessionLogout = () => {
  store.dispatch(setAlert(customConfig.sessionExpireMsg, "danger"));
  clearStoredAuthSlices();
  window.location = "/";
};

const isLoginOrRefreshRequest = (config) => {
  const url = String(config?.url || "");
  return (
    url.includes("userManagement/login") ||
    url.includes(USER_MANAGEMENT_TOKEN_REFRESH_PATH)
  );
};

const ResponseInterceptor = () => {
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    async function (error) {
      // Allow axios cancellation errors to propagate so callers can handle them correctly
      if (axios.isCancel && axios.isCancel(error)) {
        return Promise.reject(error);
      }

      const status = error.response?.status;
      const cfg = error.config;

      if (
        status === 401 &&
        cfg &&
        !cfg.skipSessionHandlers &&
        !isLoginOrRefreshRequest(cfg) &&
        window.location.pathname !== "/"
      ) {
        if (!cfg._sessionRetry) {
          try {
            const token = await refreshAccessToken();
            if (token) {
              return axios({
                ...cfg,
                _sessionRetry: true,
                headers: {
                  ...cfg.headers,
                  Authorization: `Bearer ${token}`,
                },
              });
            }
          } catch (_) {
            // fall through to hard logout
          }
        }
        sessionLogout();
        return Promise.reject(error);
      }

      // Handle timeout errors
      const errorMessage = error?.message?.toLowerCase?.() || "";
      if (
        error.code === "ECONNABORTED" ||
        errorMessage.includes("timeout") ||
        errorMessage.includes("timed out")
      ) {
        console.error("Request timeout:", error.config?.url);
        error.isTimeout = true;
        error.userMessage = customConfig.TIMEOUT_ERROR;
      }

      // Handle network errors
      if (!error.response && !error.isTimeout) {
        console.error("Network error:", error.config?.url);
        error.isNetworkError = true;
        error.userMessage = customConfig.NETWORK_ERROR;
      }

      // Updated due to axios version upgrade
      // IMPORTANT: reject so axios knows the request failed
      return Promise.reject(error);
    }
  );
};

export default ResponseInterceptor;
